import { ExternalLink } from "lucide-react";
import type { SearchResult } from "./hooks";
import {
  cleanUpSearchResultDescription,
  extractHostname,
  getFaviconUrl,
} from "./utils";

export function SearchResultItem({ result }: { result: SearchResult }) {
  const hostname = extractHostname(result.url);
  const faviconUrl = getFaviconUrl(hostname);

  return (
    <div className="group border rounded-lg p-2 hover:bg-muted/30 transition-colors">
      <div className="flex items-start gap-3">
        <img
          src={faviconUrl}
          alt={`Favicon for ${hostname}`}
          className="w-3 h-3 flex-shrink-0 mt-0.5"
          onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
            const target = e.target as HTMLImageElement;
            target.style.display = "none";
          }}
        />

        <div className="flex-1 min-w-0 space-y-0.5">
          <div className="flex items-center gap-2 flex-wrap">
            <h4 className="font-medium text-xs truncate flex-1 min-w-0">
              {result.title}
            </h4>
            <div className="flex items-center gap-2 flex-shrink-0">
              <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs bg-muted text-muted-foreground font-medium">
                {hostname}
              </span>
              <a
                href={result.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
                title="Open in new tab"
              >
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>

          {result.description && (
            <p className="text-xs text-muted-foreground truncate leading-relaxed">
              {cleanUpSearchResultDescription(result.description)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
